module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageList.length > 0),
      expression: "messageList.length > 0"
    }],
    staticClass: "ui grid container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui negative floating message sixteen wide column"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.clearMessageList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Error Message\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.messageList), function(msg) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(msg)
      }
    })
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29c77dd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorMessage.vue
// module id = 376
// module chunks = 0